export default "__VITE_ASSET__DzrE7A_m__"